<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M15 15.75c-1.043 0-2.085-.352-3-.99-1.83 1.283-4.17 1.283-6 0-.915.638-1.957.99-3 .99H1.5v1.5H3a6.621 6.621 0 0 0 3-.742c1.89.967 4.11.967 6 0a6.526 6.526 0 0 0 3 .742h1.5v-1.5H15Zm-12.037-1.5H3c1.2 0 2.265-.66 3-1.5.735.84 1.8 1.5 3 1.5s2.265-.66 3-1.5c.735.84 1.8 1.5 3 1.5h.037l1.418-5.01a.79.79 0 0 0-.045-.585.747.747 0 0 0-.45-.375L15 7.965V4.5c0-.825-.675-1.5-1.5-1.5h-2.25V.75h-4.5V3H4.5C3.675 3 3 3.675 3 4.5v3.465l-.967.315a.755.755 0 0 0-.495.96l1.424 5.01ZM4.5 4.5h9v2.978L9 6 4.5 7.478V4.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
